/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * PKCE challenge method. Only S256 is supported.
 */
export const CodeChallengeMethod = {
  S256: "S256",
} as const;
/**
 * PKCE challenge method. Only S256 is supported.
 */
export type CodeChallengeMethod = ClosedEnum<typeof CodeChallengeMethod>;

export type AuthorizeRequestBody = {
  /**
   * PKCE code challenge: base64url(sha256(code_verifier)).
   */
  codeChallenge: string;
  /**
   * PKCE challenge method. Only S256 is supported.
   */
  codeChallengeMethod: CodeChallengeMethod;
  /**
   * Optional project slug to scope the minted key to. Defaults to the org's default (first) project when omitted.
   */
  projectSlug?: string | undefined;
};

/** @internal */
export const CodeChallengeMethod$outboundSchema: z.ZodMiniEnum<
  typeof CodeChallengeMethod
> = z.enum(CodeChallengeMethod);

/** @internal */
export type AuthorizeRequestBody$Outbound = {
  code_challenge: string;
  code_challenge_method: string;
  project_slug?: string | undefined;
};

/** @internal */
export const AuthorizeRequestBody$outboundSchema: z.ZodMiniType<
  AuthorizeRequestBody$Outbound,
  AuthorizeRequestBody
> = z.pipe(
  z.object({
    codeChallenge: z.string(),
    codeChallengeMethod: CodeChallengeMethod$outboundSchema,
    projectSlug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      codeChallenge: "code_challenge",
      codeChallengeMethod: "code_challenge_method",
      projectSlug: "project_slug",
    });
  }),
);

export function authorizeRequestBodyToJSON(
  authorizeRequestBody: AuthorizeRequestBody,
): string {
  return JSON.stringify(
    AuthorizeRequestBody$outboundSchema.parse(authorizeRequestBody),
  );
}
